import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export const getSubscription = () => {
  const url = `${apiConfiguration.apiUrl}/subscriptions`;
  return axios.get<SubscriptionModel>(url);
};
